<template>
  <div class="status-list scroll-styling rounded-lg ">
    <div class="relative overflow-x-auto">

        <div
            style='max-height: 100%; overflow: hidden;'
            class="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">
            <div class="table-container inl-100 tsor-table ">

                <div class="table-row header">
                    <div
                      style="width: 60%;"
                      class="row-item bt-n bb-n br-r">
                        <span class='px-6 py-2'>
                          Название курса
                        </span>
                      </div>
                    <div
                        style="width: 15%;"
                        class="row-item bb-a-n">
                        <span class='px-6 py-2'>Цена</span>
                    </div>
                    <div
                        style="width: 25%;"
                        class="row-item bb-a-n">
                        <span class='px-6 py-2'>Действие</span>
                    </div>
                </div>

                <div v-if="courses.length > 0" >
                  <div
                      v-for="(obj, objInd) in courses" :key="objInd"
                      class="table-row body">
                      <div style="width: 60%;"
                          class="row-item br-l">
                          <span class='px-6 py-2'>{{ obj.title }}</span>
                      </div>
                      <div style="width: 15%;" class="row-item">
                          <span class='px-6 py-2'>
                            {{ obj.price && parseFloat(obj.price) > 0 ? `${obj.price} KZT` : 'Бесплатно' }}
                          </span>
                      </div>
                      <div style='width: 25%;' class="row-item">
                          <div class='flex-center fl-start px-6 py-2 inl-100'>
                              <!-- Для учеников: если платный и не оплачен -->
                              <button
                                  v-if="isStudent && obj.price && parseFloat(obj.price) > 0 && !obj.is_paid"
                                  @click.stop="openPaymentModal(obj)"
                                  class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm">
                                  Оплатить
                              </button>
                              <!-- Для всех остальных или бесплатные/оплаченные курсы -->
                              <button
                                  v-else
                                  @click.stop="goTo(obj.uuid)"
                                  class="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 text-sm">
                                  Перейти
                                  <svg class="w-3 h-3 inline ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
                                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/>
                                  </svg>
                              </button>
                          </div>
                      </div>
                  </div>
                </div>

            </div>
        </div>

    </div>

    <!-- Payment Modal -->
    <div v-if="showPaymentModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10010]">
      <div class="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold">{{ selectedCourse?.title }}</h3>
          <button @click="closePaymentModal" class="text-gray-500 hover:text-gray-700">✕</button>
        </div>

        <p class="text-gray-600 mb-4">Цена: <span class="font-bold">{{ selectedCourse?.price }} KZT</span></p>

        <p class="text-gray-600 mb-6">Для доступа к курсу требуется оплата. Нажмите кнопку ниже для перехода к платежу.</p>

        <div class="flex gap-3">
          <button
            @click="closePaymentModal"
            class="flex-1 px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400">
            Отмена
          </button>
          <button
            @click="initiatePayment(selectedCourse)"
            :disabled="paymentLoading"
            class="flex-1 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300">
            {{ paymentLoading ? 'Обработка...' : 'Оплатить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CLIENT, BASE_URL, HEADERS_TOKEN_JSON } from "@/const/uri";

export default {
  components: {},
  data() {
    return {
      clientToken: null,
      courses: [],
      courseUUID: null,
      tableKeyStr: [],
      tableDataFilter: [],
      showPaymentModal: false,
      selectedCourse: null,
      paymentLoading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    isStudent() {
      return this.$store.state.user?.role?.key === 1;
    },
  },
  methods: {
    goTo(uuid) {
      this.$router.push({
        name: 'ClienntTsorTitles',
        params: {
          uuid,
        },
      })
    },
    async loadData() {
      await axios({
        method: "GET",
        url: API_CLIENT.studentCourse,
        data: {},
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          const data = e.data.data;
          this.courses = data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    openPaymentModal(course) {
      this.selectedCourse = course;
      console.log('this.selectedCourse:', this.selectedCourse,);
      this.showPaymentModal = true;
    },
    closePaymentModal() {
      this.showPaymentModal = false;
      this.selectedCourse = null;
    },
    async initiatePayment(course) {
      this.paymentLoading = true;

      try {
        const response = await axios.post(
          `${BASE_URL}/api/payment/orders/`,
          {
            course_id: course.uuid,
          },
          {
            headers: HEADERS_TOKEN_JSON(),
          }
        );

        const data = response.data.data;

        if (data.status === 'already_paid') {
          alert('Вы уже оплатили этот курс');
          this.closePaymentModal();
        } else if (data.status === 'processing' && data.redirect_url) {
          // Open FreedomPay payment page in new window
          window.open(data.redirect_url, '_blank');
          this.closePaymentModal();
        } else {
          alert('Ошибка при создании платежа');
        }
      } catch (e) {
        console.log('Payment error:', e);
        const errorData = e.response?.data?.data;

        // Handle payment_pending status (active payment attempt)
        if (errorData?.status === 'payment_pending' && errorData?.redirect_url) {
          window.open(errorData.redirect_url, '_blank');
          return;
        }

        if (errorData?.message) {
          alert(errorData.message);
        } else {
          alert('Ошибка при обработке платежа');
        }
      } finally {
        this.paymentLoading = false;
      }
    },
  },
  props: {},
};
</script>